export default class FundDashboardResponseModel {
    public authorizedOperations: number = 0;
    public fundId: number = 0;
    public fundName: string = '';
    public bankAccountId: number = 0;
    public notes: string = '';
    public isDepositFund: boolean = false;
    public debits: number = 0;
    public credits: number = 0;
    public balance: number = 0;
    public createdDateTimeUtc?: Date;
    public createdBy: string = '';
}
